import SimpleUpload from './SimpleUpload';

export * from './SimpleUploadProps';
export default SimpleUpload;
